import React, { memo, useState } from 'react';
import useMedia from '../../app/hooks/useMedia';
import { CSS } from './css/css';

import { Link } from 'react-router-dom';

import { titleItems, navItems } from './items/Items'
import { useEffect } from 'react';

const Solution = memo(() => {
   const { CONTAINER, TITLE, NAV, DISPLAY } = CSS
   const media = useMedia('(max-width: 1023px)')

   const [ nav, setNav ] = useState({
      items: navItems.map((n, ndex) => ndex === 0 ? {
         ...n, select: true,
      } : {
         ...n, select: false,
      }),
   })

   const [ width, setWidth ] = useState(null)
   useEffect(() => {
      const root = document.getElementById('root')
      setWidth(w => root.offsetWidth)
   }, [])
   useEffect(() => {
      const resize = function(event) {
         const root = document.getElementById('root')
         setWidth(w => root.offsetWidth)
      }
      window.addEventListener('resize', resize)
      return () => {
         window.removeEventListener('resize', resize)
      }
   }, [])

   return (
      <CONTAINER Media={media}>
         <TITLE Media={media}>
            <span>{titleItems.subTitle}</span>
            <h1>{titleItems.title}</h1>
            <Link to={'/contact#email'}>
               {`프로젝트 의뢰`}
            </Link>
         </TITLE>
         <NAV Media={media}>
            {nav.items.map((ni, nidex) =>
               <Button key={nidex}
                  style={ni.select ? { backgroundColor: `rgb(245 179 165)`} : {}}
                  onClick={event => {
                     setNav(n => ({
                        ...n,
                        items: n.items.map((i, idex) => 
                           idex === nidex ? {
                              ...i, select: true
                           } : {
                              ...i, select: false
                           }
                        )
                     }))
                  }}
               >
                  {ni.title.split(/\s/).map((t, tdex) => 
                     <span key={tdex}>{ t }</span>
                  )}
               </Button>
            )}
         </NAV>
         <DISPLAY Media={media} Width={width}>
         {nav.items.map((ni, nidex) => 
            ni.select && 
            <Display key={nidex}>
               <h1>“{ni.label}”</h1>
               <div className={'Img'}>
                  <img src={ni.img} alt={ni.title} />
               </div>
            </Display>
         )}
         </DISPLAY>
      </CONTAINER>
   );
});

export default Solution;

const Button = memo((props) => {
   const { ...rest } = props
   return (
      <button
         { ...rest }
      >
         { props.children }
      </button>
   )
})

const Display = memo((props) => {

   return (
      <div>
         { props.children }
      </div>
   )
})